<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  area: {
    type: String,
    required: true
  }
})

const route = useRoute()
const areaListTitle = '各地の風の予報'
const prefList = areaToPrefTable.find(({ key }) => key === props.area).pref_list
</script>

<template>
  <section class="satelliteList">
    <SectionTitle :title="areaListTitle" />
    <div class="content">
      <NuxtLink
        v-for="pref in prefList"
        :key="pref.key"
        :to="`${route.path}${pref.key}/`"
        class="link"
      >
        {{ pref.name }}
      </NuxtLink>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.satelliteList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    padding: 10px;
    background-color: #EEF1F8;
  }
  .link {
    position: relative;
    width: calc((100% - 10px) / 3);
    padding: 9px 5px 8px;
    border-radius: 2px;
    border: 1px solid #3569C0;
    background-color: #fff;
    color: #3569C0;
    font-size: 15px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    user-select: none;
    &::after {
      position: absolute;
      bottom: 4px;
      right: 4px;
      width: 9px;
      height: 9px;
      background-color: #3569C0;
      clip-path: polygon(100% 0, 100% 100%, 0 100%);
      content: '';
    }
    @media (any-hover: hover) {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}

.main {
  .satelliteList {
    @media screen and (min-width: 830px) {
      .content {
        gap: 8px;
      }
      .link {
        width: calc(25% - 6px);
      }
    }
  }
}
</style>
